<div class="maf-review">
  <app-submission-summary-card class="maf-review__card" [card]="mafCard" [showEditAction]="false"
    [appReviewMafMode]="true" [appReviewMafUnsigned]="shouldShowNeedSignedMafSupportBanner"
    [mafCompletionMode]="'online'" [appReviewActionLabel]="mafActionLabel" [appReviewActionIcon]="mafActionIcon"
    [appReviewActionMeta]="mafActionMeta" [appReviewTopLeftBadge]="mafTopLeftBadge"
    [appReviewInfoPanelTitle]="mafInfoPanelTitle" [appReviewInfoPanelText]="mafInfoPanelText"
    [suppressMafFileList]="shouldShowCommonMafInfoForSelectedApplicant"
    [showAppReviewAction]="!isReadOnly && showMafAppReviewAction" [showAppReviewUploadAction]="!isReadOnly"
    [showMafDeleteAction]="!isReadOnly" (mafViewClicked)="onMafView($event)"
    (mafDownloadClicked)="onMafDownload($event)" (mafDeleteClicked)="onMafDelete($event)"
    (appReviewActionClicked)="onDigitalFormAction()" (appReviewUploadClicked)="onMafUploadAction()">
  </app-submission-summary-card>

  <app-submission-summary-card class="maf-review__card" [card]="merCard" [showEditAction]="false"
    [appReviewMafMode]="true" [mafCompletionMode]="'online'" [appReviewActionLabel]="'Upload Additional MER'"
    [appReviewActionIcon]="'upload'"
    [appReviewDescription]="'Upload medical examination record. Only one MER document can be uploaded.'"
    [showAppReviewAction]="!isReadOnly && !hasMerFile" [showAppReviewUploadAction]="!isReadOnly"
    [showMafDeleteAction]="!isReadOnly" (mafViewClicked)="onMafView($event)"
    (mafDownloadClicked)="onMafDownload($event)" (mafDeleteClicked)="onMafDelete($event)"
    (appReviewActionClicked)="onMerAction()" (appReviewUploadClicked)="onMerAction()">
  </app-submission-summary-card>

  @if (showPreviewModal && previewFile) {
  <app-document-preview-modal [title]="previewFile.fileName" [tags]="previewFile.tags"
    [fileUrl]="previewFile.viewUrl ?? null" (close)="closePreviewModal()">
    <div custom-footer class="preview-modal-footer">
      <span class="preview-modal-footer__label">Download the document as a PDF?</span>
      <div class="preview-modal-footer__actions">
        <app-buttons [variant]="'secondary'" label="Download as PDF" (clicked)="onMafDownload(previewFile)">
        </app-buttons>
      </div>
    </div>
  </app-document-preview-modal>
  }

  @if (showDeleteModal) {
  <app-popup-modal class="cancel-modal-popup" [width]="'450px'" [title]="deleteModalTitle"
    [buttons]="deletePopupButtons" [imageSrc]="images.Cancel_Logo" [isCloseIcon]="true"
    (closePopupModal)="closeDeleteModal()">
    <div custom-content-below class="cancel-msg delete-popup-content">
      @if (showSharedMafDeleteContent) {
      <p class="delete-popup-desc">
        <strong>This MAF is shared across applicants.</strong> Deleting it will permanently remove the MAF for all
        linked
        applicants and reset their verification status.
      </p>
      <p class="delete-affected-applicants">
        <span>Affected Applicants: </span>
        @for (applicantName of sharedMafAffectedApplicantNames; track applicantName; let last = $last) {
        <strong>{{ applicantName }}</strong>@if (!last) { <span class="applicant-separator">·</span> }
        }
      </p>
      } @else {
      <p class="delete-popup-desc">This action will permanently remove the currently uploaded document and reset its
        verification status.</p>
      }
      <p class="delete-confirmation-text">Are you sure you want to proceed?</p>
    </div>
  </app-popup-modal>
  }

  @if (showOfflineMafUploadPopup) {
  <app-popup-modal class="offline-maf-upload-popup" [width]="'700px'" [title]="'Upload Offline MAF'"
    [isCloseIcon]="true" (closePopupModal)="onOfflineMafUploadPopupClose()">
    <div custom-content-below class="offline-maf-upload-popup__content">
      <app-maf-file-upload [mode]="'offline'" [members]="offlineMafPopupMembers" [isUploadLocked]="isReadOnly"
        [showDownloadSection]="false" [initialCoversMultipleMembers]="offlinePopupCoversMultipleMembers"
        [showDependentUploadBlocks]="!isPrimaryApplicantSelected" [useExternalPreview]="true"
        (previewRequested)="onOfflineMafPreviewRequested($event)"
        (bulkUploadRequested)="onOfflineMafBulkUploadRequested($event)"
        (deleteFileRequested)="onOfflineMafDeleteRequested($event)">
      </app-maf-file-upload>
    </div>
  </app-popup-modal>
  }

  @if (showMerUploadPopup) {
  <app-popup-modal class="offline-maf-upload-popup" [width]="'700px'" [title]="'Upload MER'" [isCloseIcon]="true"
    (closePopupModal)="onMerUploadPopupClose()">
    <div custom-content-below class="offline-maf-upload-popup__content">
      <app-maf-file-upload [mode]="'offline'" [members]="merPopupMembers" [isUploadLocked]="isReadOnly"
        [showDownloadSection]="false" [initialCoversMultipleMembers]="false" [showDependentUploadBlocks]="false"
        [useExternalPreview]="true" [showCopyBadge]="false" [offlineHeaderTitle]="'Upload MER'"
        [offlineHeaderSubtitle]="'Upload the scanned copies of the MER for each applicant below.'"
        [dropZoneText]="'Drop your MER here'" [criteriaGuidance]="'Ensure all pages are legible and clearly visible.'"
        [previewDocumentTag]="'MER'" (previewRequested)="onMerPreviewRequested($event)"
        (bulkUploadRequested)="onMerBulkUploadRequested($event)" (deleteFileRequested)="onMerDeleteRequested($event)">
      </app-maf-file-upload>
    </div>
  </app-popup-modal>
  }
</div>